module.exports = __webpack_public_path__ + "static/media/img7.0cbcc8c5.png";